// extracted by mini-css-extract-plugin
export default {"diseasesContainer":"Medicals_diseasesContainer__MXepN"};